export const REQUIRED_FIELD_MESSAGE = 'This field is required.' as const;

export const FALLBACK_ERROR_MESSAGE =
  'Something went wrong, please try again. If problem persists, please contact support for assistance.' as const;
